import { render } from "./current-work-table.vue?vue&type=template&id=72d17baf&scoped=true&ts=true"
import script from "./current-work-table.vue?vue&type=script&lang=ts"
export * from "./current-work-table.vue?vue&type=script&lang=ts"

import "./current-work-table.vue?vue&type=style&index=0&id=72d17baf&lang=less&scoped=true"
import "./current-work-table.vue?vue&type=style&index=1&id=72d17baf&lang=less"

import exportComponent from "/builds/workshop/teambition-frontend/node_modules/.pnpm/vue-loader@16.8.3_6zog4g7lmcedlfqueoidvwcx7q/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d17baf"]])

export default __exports__